export default __webpack_public_path__ + "static/media/img-0758-slovenia-full-face.1b8f7dee.png";